import React from 'react';
import { config } from '@shakkerai/config';
import { isMainland } from '@shakkerai/pro-utils';
import logoNew from './assets/logo_new.png';
import { translate } from '@shakkerai/util-i18n';
import picLogo from './assets/logo.png';
import { Tooltip } from '@mantine/core';
import './navbar.scss';

export const Brand = React.memo(() => {
  const goHome = () => {
    if (config && config.env === 'aws') {
      window.location.href = '/';
    } else {
      window.location.href = '/projects';
    }
  };

  return (
    <div onClick={goHome} className="flex items-center justify-center h-8 mr-2 cursor-pointer shadow-light">
      <Tooltip
        withArrow
        position="bottom"
        className="scale-90"
        label={translate(isMainland ? 'back_projects' : 'gallary_home')}
      >
        {isMainland ? (
          <img draggable={false} src={picLogo} className="h-[18px]" />
        ) : (
          <img draggable={false} className="w-8 h-8" src={logoNew} />
        )}
      </Tooltip>
    </div>
  );
});
